/**
 * Constrains the given angle in degrees to be between 0 and 360.
 *
 * Also covers negative angles.
 */
export function modDeg(angle: number): number {
  return ((angle % 360) + 360) % 360;
}
